import {Typography} from '@mui/material';
import Button from '@mui/material/Button';
import {memo} from 'react';

const WidgetDivider= ({ label, value, onChange, children }) => {
  return (
    <>
      <Button
        variant='contained'
        onClick={(e) => onChange(!value)}
        color={'secondary'}
        sx={{
          height: '30px',
          width: '100%',
          backgroundColor: value ? '#9C9EB7' : 'primary',
          boxShadow: value
            ? 'inset 3px 3px 3px rgba(0,0,0,0.3), inset -1px -1px 2px rgba(0,0,0,0.1)'
            : '3px 3px 3px rgba(0,0,0,0.3)',
          '&:hover': {
            backgroundColor: value ? '#8a8eb6' : 'primary',
            boxShadow: value
            ? 'inset 3px 3px 3px rgba(0,0,0,0.3), inset -1px -1px 2px rgba(0,0,0,0.1)'
            : '3px 3px 3px rgba(0,0,0,0.3)',
          },
        }}
      >
        <Typography fontSize={10}
                    fontWeight={'bold'}>
          {label}
        </Typography>
      </Button>
      {children}
    </>
  );
};

export default memo(WidgetDivider);